import { useEffect, useMemo, useState } from 'react'
import { fetchMilestonesTimeline } from '../services/milestonesClient'
import { STRATEGIC_PROJECTS, buildStrategicCountdownSnapshot } from '../utils/strategicCountdown'

export function useStrategicCountdownData() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [timelineByProject, setTimelineByProject] = useState({})
  const currentYear = new Date().getFullYear()

  useEffect(() => {
    let cancelled = false

    async function loadStrategicCountdown() {
      setLoading(true)
      setError('')

      try {
        const responses = await Promise.all(
          STRATEGIC_PROJECTS.map(async project => {
            const result = await fetchMilestonesTimeline({ project_id: project.id })
            return [project.id, result?.units || []]
          })
        )

        if (!cancelled) {
          setTimelineByProject(Object.fromEntries(responses))
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load strategic countdown')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadStrategicCountdown()
    return () => {
      cancelled = true
    }
  }, [])

  const snapshot = useMemo(
    () => buildStrategicCountdownSnapshot(timelineByProject, currentYear),
    [currentYear, timelineByProject]
  )

  return {
    currentYear,
    error,
    loading,
    timelineByProject,
    ...snapshot
  }
}
